export default function CTASection() {
  return (
    <section className="relative w-full py-20 md:py-28 flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20soft%20gradient%20composition%20with%20warm%20cream%20oat%20and%20terracotta%20tones%2C%20subtle%20organic%20shapes%20and%20gentle%20curves%2C%20minimalist%20artistic%20background%2C%20no%20objects%2C%20elevated%20modern%20aesthetic%2C%20soft%20diffused%20light%2C%20calming%20editorial%20design&width=1600&height=800&seq=cta-vigorbuy-v3&orientation=landscape"
          alt="Explore the VigorBuy Spreadsheet resources"
          className="w-full h-full object-cover object-center"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/55"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full px-6 md:px-10 text-center">
        <h2 className="text-3xl md:text-5xl font-heading text-white mb-4 leading-tight">
          Explore the Latest VigorBuy<br className="hidden sm:block" /> Spreadsheet Resources Today
        </h2>
        <p className="text-base md:text-lg text-white/75 mb-8 max-w-xl mx-auto">
          Find the best deals on shoes, hoodies, and accessories. All products updated weekly on
          VigorBuy.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-8 py-3.5 bg-white text-foreground-900 text-sm md:text-base font-semibold rounded-full hover:bg-background-100 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            Buy It Now
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-arrow-right-up-line text-base"></i>
            </div>
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-8 py-3.5 border-2 border-white/60 text-white text-sm md:text-base font-medium rounded-full hover:bg-white/15 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            VigorBuy Sheet
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-arrow-right-up-line text-base"></i>
            </div>
          </a>
        </div>
      </div>
    </section>
  );
}